// extracted by mini-css-extract-plugin
export default {"select":"CopyScriptModal_select__THDnE","btn":"CopyScriptModal_btn__henXe"};